import numbro from 'numbro';

export const deDeLocaleData: numbro.NumbroLanguage = {
  languageTag: 'de-DE',
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    // https://unicode-org.github.io/cldr-staging/charts/38/verify/numbers/de.html
    thousand: '\xa0Tsd.',
    million: '\xa0Mio.',
    billion: '\xa0Mrd.',
    trillion: '\xa0Bio.',
  },
  ordinal: function () {
    return '.';
  },
  spaceSeparated: true,
  currency: {
    symbol: '€',
    // We override this to always have currency as a prefix
    position: 'prefix',
    code: 'EUR',
  },
  currencyFormat: {
    totalLength: 4,
    thousandSeparated: true,
  },
  formats: {
    fourDigits: {
      totalLength: 4,
      spaceSeparated: true,
      average: true,
    },
    fullWithTwoDecimals: {
      output: 'currency',
      mantissa: 2,
      spaceSeparated: true,
      thousandSeparated: true,
    },
    fullWithTwoDecimalsNoCurrency: {
      mantissa: 2,
      thousandSeparated: true,
    },
    fullWithNoDecimals: {
      output: 'currency',
      spaceSeparated: true,
      thousandSeparated: true,
      mantissa: 0,
    },
  },
};
